export default __webpack_public_path__ + "static/media/yellow-1.d071b647.png";